module.exports = __webpack_public_path__ + "img/upnew.c98f058f.png";